import React from 'react';
import { useState, useEffect } from 'react';
import classes from './CreateComment.module.css';
import { articleActions } from '../store/articleSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

let send = false;
const CreateComment = (props) => {
  const [todaysDate, setTodaysDate] = useState('');
  const blogItemList = useSelector(state => state.article.items);
  const dispatch = useDispatch();
  const [comment, setComment] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch('https://codinguniverse-20c51-default-rtdb.firebaseio.com/article.json');
      const data = await response.json();
      dispatch(articleActions.replace(data.items));
    }
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const currentDate = new Date();

    const options = {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    };

    const formattedDate = currentDate.toLocaleDateString(undefined, options);
    setTodaysDate(formattedDate);
  }, [])

  const addCommentHandler = (event) => {
    event.preventDefault();

    if(comment?.length !== 0) {
      dispatch(articleActions.addComment({ id: props.articleId, comment: comment, user: props.user, date: todaysDate }));
    }
    setComment('');
  }

  useEffect(() => {
    const sendData = async () => {
      if (send === false) {
        send = true;
        return;
      }
      await fetch('https://codinguniverse-20c51-default-rtdb.firebaseio.com/article.json', {
        method: "PUT",
        body: JSON.stringify({ items: blogItemList })
      })
    }
    sendData();
  }, [blogItemList]);

  return (
    <div className={classes.createComments}>
      <h2>Resposnse</h2>
      <div className={classes.inputForm}>
        <h4><i class="fa-solid fa-user"></i> {props?.user}</h4>
        <textarea name="" placeholder="What are your thoughts?" value={comment} onChange={(event) => { setComment(event.target.value) }} cols="30" rows="2"></textarea>

        <div className={classes.addComment}>
          <button onClick={addCommentHandler}>Respond</button>
        </div>

      </div>
    </div>
  );
}

export default CreateComment;